/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of an organizational approval process
 * @export
 * @interface B2BApprovalProcess
 */
export interface B2BApprovalProcess {
    /**
     * Code of the Organizational Approval Process
     * @type {string}
     * @memberof B2BApprovalProcess
     */
    code: string;
    /**
     * Name of the Organizational Approval Process
     * @type {string}
     * @memberof B2BApprovalProcess
     */
    name?: string;
}

/**
 * Check if a given object implements the B2BApprovalProcess interface.
 */
export function instanceOfB2BApprovalProcess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function B2BApprovalProcessFromJSON(json: any): B2BApprovalProcess {
    return B2BApprovalProcessFromJSONTyped(json, false);
}

export function B2BApprovalProcessFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BApprovalProcess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function B2BApprovalProcessToJSON(value?: B2BApprovalProcess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

